/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICittaAnchorConfig, ICittaAnchorProps } from './citta-anchor.props.autogenerated';

export interface ICittaAnchorViewProps extends ICittaAnchorProps<ICittaAnchorConfig> {
    Anchor: INodeProps;
}

/**
 *
 * CittaAnchor component
 * @extends {React.PureComponent<ICittaAnchorProps<ICittaAnchorConfig>>}
 */
class CittaAnchor extends React.PureComponent<ICittaAnchorProps<ICittaAnchorConfig>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const anchorId = config && config.anchorName && config.anchorName.replace(/\s/g, '');

        const viewProps: ICittaAnchorViewProps = {
            ...(this.props as ICittaAnchorProps<ICittaAnchorConfig>),

            Anchor: {
                id: anchorId,
                className: ''
            }
        };
        return this.props.renderView(viewProps);
    }
}

export default CittaAnchor;
